var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 5.07452 0 2.81178 1.44101 1.40589C2.88202 0 5.20129 0 9.83984 0H12.2998C16.9383 0 19.2576 0 20.6986 1.40589C22.1396 2.81178 22.1396 5.07452 22.1396 9.6V12V14.4C22.1396 18.9255 22.1396 21.1882 20.6986 22.5941C19.2576 24 16.9383 24 12.2998 24H9.83984C5.20129 24 2.88202 24 1.44101 22.5941C0 21.1882 0 18.9255 0 14.4V9.6Z",
    fill: "url(#paint0_linear_3369_6605)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0284 17.4016C20.2436 17.2378 20.4388 17.0473 20.8293 16.6664L25.6941 11.9201C25.8117 11.8054 25.759 11.6044 25.6034 11.5517C25.0288 11.3572 24.2814 10.9921 23.5823 10.31C22.8832 9.62792 22.5089 8.89873 22.3096 8.33819C22.2545 8.18324 22.0551 8.12955 21.9374 8.2444L17.0671 12.9959L17.0671 12.9959C16.6767 13.3769 16.4815 13.5673 16.3136 13.7773C16.1155 14.0251 15.9457 14.2931 15.8072 14.5767C15.6897 14.8171 15.6024 15.0727 15.4278 15.5837L15.2022 16.2441L14.8434 17.2942L14.507 18.2787C14.4211 18.5302 14.4882 18.8075 14.6804 18.995C14.8725 19.1824 15.1567 19.2479 15.4145 19.1641L16.4237 18.8359L17.5 18.4859L18.1768 18.2657L18.1769 18.2657C18.7007 18.0954 18.9626 18.0102 19.209 17.8956C19.4997 17.7605 19.7744 17.5948 20.0284 17.4016Z",
    fill: "#D9C9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2208 10.4306C28.2597 9.41705 28.2597 7.77374 27.2208 6.76017C26.1819 5.74661 24.4976 5.74661 23.4587 6.76017L23.2994 6.91557C23.1505 7.06089 23.0829 7.26637 23.1205 7.47103C23.1442 7.60003 23.1882 7.78864 23.2683 8.01369C23.4283 8.46377 23.7305 9.05458 24.2998 9.60998C24.8691 10.1654 25.4747 10.4603 25.936 10.6164C26.1667 10.6945 26.36 10.7374 26.4922 10.7606C26.7028 10.7974 26.9141 10.7299 27.0671 10.5806L27.2208 10.4306Z",
    fill: "#D9C9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4802 9.68866C15.823 9.32872 15.8091 8.75904 15.4491 8.41625C15.0892 8.07345 14.5195 8.08734 14.1767 8.44728L8.53325 14.2351L6.67576 12.3417C6.33297 11.9817 5.76329 11.9989 5.40335 12.3417C5.04341 12.6845 5.02952 13.2231 5.37232 13.583L7.88152 16.1608C8.05139 16.3392 8.28694 16.4401 8.53325 16.4401C8.77956 16.4401 9.0151 16.3392 9.18497 16.1608L15.4802 9.68866Z",
    fill: "#D9C9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3369_6605",
    x1: 2.19657,
    y1: 1.91066,
    x2: 19.7425,
    y2: 22.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7657FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWrite);
export default __webpack_public_path__ + "static/media/check-write.5756504d0358bffaf73f76fe85ff1986.svg";
export { ForwardRef as ReactComponent };